import styled from 'styled-components';
import { applyWidth, Width } from '@trevor/ui-components';

export const ActivityInfoItem = styled.li`
  border-bottom: 1px solid #d4d4d4;
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  line-height: 20px;
  padding-block: 16px;

  &:not(:first-child) {
    span + span,
    a + span {
      padding-right: 32px;
    }
  }

  a {
    color: #224b67;
    text-decoration: underline;
  }
`;

export const ActivityListHeader = styled(ActivityInfoItem)`
  font-weight: 700;
  position: sticky;
  top: 0;

  span + span {
    padding-right: 12px;
  }
`;

export const ActivitySeeMore = styled.li`
  display: flex;
  justify-content: space-between;
  padding-top: 16px;
`;

export const SeeMoreButton = styled.button`
  --color: #224b67;

  border: 2px solid var(--color);
  border-radius: 50px;
  padding: 8px 24px;

  span {
    color: var(--color);
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
  }
`;

export const ActivityList = styled.ul`
  list-style: none;
  margin: 0;
  max-height: 690px;
  min-height: calc(53px * 3 + 52px); // height of a list header + 3 list items
  overflow-y: auto;
  padding: 24px;
  padding-top: 0;
  width: 100%;

  &:not(:has(${ActivitySeeMore})) {
    ${ActivityInfoItem}:last-child {
      border-bottom: none;
    }
  }
`;

export const LoadingPlaceholder = styled.span<{
  $width: Width;
  $animationDelay: number;
}>`
  @keyframes blink {
    50% {
      opacity: 0.5;
    }
  }

  animation: blink 1s ease-in-out infinite;
  animation-delay: ${(p) => p.$animationDelay}s;
  background-color: #d4d4d4;
  border-radius: 4px;
  display: block;
  height: 16px;
  ${applyWidth}
`;
